import { useState } from "react";
import { Btn, FieldLabel, Input, Modal } from "components/ui/index";
import { WALLET_COLORS, WALLET_ICONS } from "constants/index";
import { T } from "theme/index";
import { fmtNum, parseNum, uid } from "utils/format";

// ── Wallet Modal ──────────────────────────────────────────────────────────────
export default function WalletModal({ wallet, onSave, onClose }) {
  const [f, setF] = useState(wallet || { id:uid(), name:"", bank:"", icon:"🏦", color:"#0070BB", initialBalance:"" });
  const set = (k, v) => setF(p => ({ ...p, [k]:v }));
  return (
    <Modal title={wallet ? "Edit Rekening" : "Tambah Rekening"} onClose={onClose}>
      <div style={{ marginBottom:14 }}>
        <FieldLabel>Ikon Rekening</FieldLabel>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
          {WALLET_ICONS.map(ic => (
            <button key={ic} onClick={() => set("icon",ic)} style={{ width:38, height:38, borderRadius:8, fontSize:20, cursor:"pointer", background:f.icon===ic?T.gold+"22":T.surface, border:`1px solid ${f.icon===ic?T.gold:T.border}`, WebkitTapHighlightColor:"transparent" }}>{ic}</button>
          ))}
        </div>
      </div>
      <div style={{ marginBottom:14 }}>
        <FieldLabel>Warna</FieldLabel>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
          {WALLET_COLORS.map(c => (
            <button key={c} onClick={() => set("color",c)} style={{ width:28, height:28, borderRadius:6, background:c, border:`2px solid ${f.color===c?"#fff":"transparent"}`, cursor:"pointer", WebkitTapHighlightColor:"transparent" }} />
          ))}
        </div>
      </div>
      <Input label="Nama Rekening" value={f.name} onChange={e => set("name",e.target.value)} placeholder="BCA Utama, Gopay, dll" />
      <Input label="Nama Bank / Platform" value={f.bank} onChange={e => set("bank",e.target.value)} placeholder="Bank BCA, GoPay, OVO, dll" />
      <Input label="Saldo Awal (Rp)" type="text" inputMode="numeric" value={fmtNum(f.initialBalance)} onChange={e => set("initialBalance",e.target.value.replace(/\D/g,""))} placeholder="0" />
      <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:4 }}>
        <Btn variant="ghost" onClick={onClose}>Batal</Btn>
        <Btn onClick={() => { if(f.name){ onSave({ ...f, initialBalance:parseNum(f.initialBalance) }); onClose(); }}} disabled={!f.name}>💾 Simpan</Btn>
      </div>
    </Modal>
  );
}
